import React from 'react';

import { AnalyticsConsumerProps, withAnalytics } from '../hoc/withAnalytics';
import { PageContent } from '../model/PageContent';

interface Props {
  emptyState?: boolean;
  pageContent: PageContent;
}

/**
 * An empty component to signify that 'some' content has been loaded on the page.
 * This is used for the purpose of apdex to track page load performance.
 *
 * This component is safe to be rendered multiple times and at many different places.
 * The actual emitting of apdex event will only happen once.
 */
class PageContentLoaded extends React.PureComponent<Props & AnalyticsConsumerProps> {
  componentDidMount() {
    const { pageContent, emptyState } = this.props;
    this.props.analytics.markContentLoad(pageContent, Boolean(emptyState));
  }

  render() {
    return null;
  }
}

export default withAnalytics(PageContentLoaded);
